<div class="main-box" [class.main-box--drag-over]="isValidDragOver"
    [class.main-box--drag-not-valid]="dragNotValid || dragRegionNotValid" (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

    <ng-container *hasPermission="[PERM.EDIT, PERM.MODULE]">
        <button *ngIf="!isValidDragOver && !dragNotValid && !dragRegionNotValid" type="button"
            class="main-box__absences-button main-box--secondary-info" mat-icon-button #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menu">
            <mat-icon>settings</mat-icon>
        </button>
    </ng-container>

    <div class="text-align-center flex-grow pointer-events-none flexContent justify-center align-center">
        <div *ngIf="isValidDragOver">Upuść element, aby dodać trasę</div>
        <div *ngIf="dragNotValid">Przeciągnij zgłoszenie na zlecenia, aby utworzyć zlecenie i móc je przypisać do
            kierowcy</div>
        <div *ngIf="dragRegionNotValid">Spółka dla zlecenia nie odpowiada spółce kierowcy/pojazdu</div>
    </div>
    <div class="main-box__box-fotter pointer-events-none">
    </div>
</div>


<mat-menu #menu="matMenu" xPosition="before">

    <ng-container *hasPermission="[PERM.ACCESS.TODRIVERS, PERM.EDIT, PERM.MODULE]">
        <button type="button" mat-menu-item (click)="onAddAbsenceClick(businessObjectType.DRIVER, driver.driverId)">
            <mat-icon>person_alert</mat-icon>
            <span>Dodaj niedostępność dla kierowcy</span>
        </button>
    </ng-container>

    <ng-container *hasPermission="[PERM.ACCESS.TOVEHICLES, PERM.EDIT, PERM.MODULE]">
        <button type="button" mat-menu-item (click)="onAddAbsenceClick(businessObjectType.VEHICLE, driver.vehicleId)">
            <mat-icon>directions_bus</mat-icon>
            <span>Dodaj niedostępność dla pojazdu</span>
        </button>
    </ng-container>

    <ng-container *hasPermission="[PERM.ACCESS.TOVEHICLES, PERM.EDIT, PERM.MODULE]">
        <button *ngIf="driver.trailerId" type="button" mat-menu-item
            (click)="onAddAbsenceClick(businessObjectType.VEHICLE, driver.trailerId)">
            <mat-icon>rv_hookup</mat-icon>
            <span>Dodaj niedostępność dla przyczepy</span>
        </button>
    </ng-container>
</mat-menu>